export const IMAGES_EXTENSION_TYPES = ['png', 'jpg', 'jpeg', 'JPG', 'PNG', 'JPEG']
